import axios from 'axios';
import { mutate } from 'swr';
import { Notistack } from '../../../../shared/components/Notistack/Notistack';
import { RuleType } from './types';

export const requestUpdateRule = (providerId: string, productTypeId: string, ruleData: RuleType) => {
  const path = `/product-service/providers/${providerId}/productTypes/${productTypeId}/rules`;
  return mutate(path, async() => {
    try {
      await axios.put(`${path}/${ruleData.id}`, ruleData);
      Notistack.successMessage('Product Rule - Updated Successfully');
    } catch {
      Notistack.generalError();
    }
  });
};

export const requestCreateRule = (ruleData: RuleType) => {
  const path = `/product-service/providers/${ruleData.providerId}/productTypes/${ruleData.productTypeId}/rules`;
  return mutate(path, async() => {
    try {
      await axios.post(path, ruleData);
      Notistack.successMessage('Product Rule - Created Successfully');
    } catch {
      Notistack.generalError();
    }
  });
};

export const requestDeleteRule = (ruleData: RuleType) => {
  const path = `/product-service/providers/${ruleData.providerId}/productTypes/${ruleData.productTypeId}/rules`;
  return mutate(path, async() => {
    try {
      await axios.delete(`${path}/${ruleData.id}`);
      Notistack.successMessage('Product Rule - Deleted Successfully');
    } catch {
      Notistack.generalError();
    }
  });
};
